import LayoutManager from "../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractInstaller from "../core/application/AbstractInstaller";
import FullScreenButton from "./domcontrols/FullScreenButton";
import ResizeManager from "./ResizeManager";

export default class LayoutInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("resizeManager", ResizeManager, true);
        injector.mapClass("layoutManager", LayoutManager, true);
        injector.mapClass("fullScreenButton", FullScreenButton, true);

        // Initialization
        injector.getValue("resizeManager").initialize();
        injector.getValue("fullScreenButton").initialize();
    }
}